module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "基础注册促销",
      "name": "first"
    }
  }, [_c('general', {
    attrs: {
      "get-status": _vm.general_status
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "赠送(付费会员卡)",
      "name": "third"
    }
  }, [_c('sale-member-card', {
    attrs: {
      "get-status": _vm.sale_member_card
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "注册送积分",
      "name": "fourth"
    }
  }, [_c('point', {
    attrs: {
      "get-status": _vm.point
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-170ab1b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-170ab1b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/index.vue
// module id = 2495
// module chunks = 0